<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="商品名称">
                  <el-input style="width: 200px" v-model="queryForm.productName"></el-input>
              </el-form-item>
              <el-form-item label="所属门店">
<!--                  <el-input  v-model="queryForm.storeId"></el-input>-->
                  <GridSelectShop
                      style="width: 200px"
                      title="选择所属店铺"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      @getValue="getValueShopId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectShop>
              </el-form-item>
              <el-form-item label="商品状态">
<!--                  <el-input  v-model="queryForm.isShow"></el-input>-->
                  <el-select style="width: 200px;" v-model="queryForm.isShow" placeholder="请选择" clearable size="small">
                    <el-option
                      v-for="item in productStatusEnumList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreGroupbuyList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopStoreGroupbuy"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopStoreGroupbuy(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStoreGroupbuy(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopStoreGroupbuyList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStoreGroupbuyList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='left' prop='productName' label='商品信息'
                         width='150'>
            <template slot-scope='scope'>
                <div style='text-align: left'>名称：{{ scope.row.productName }}</div>
                <div style='text-align: left'>货号：{{ scope.row.productNumber }}</div>
            </template>
        </el-table-column>
        <el-table-column align='center' label='图片' width='150'>
            <template slot-scope='scope'>
                <el-image
                    @click='updateSrcList(scope.row.productPic)'
                    style='width: 80px; height: 80px'
                    :src='scope.row.productPic'
                    :preview-src-list='srcList'
                ></el-image>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' label='价格' width='150'>
            <template slot-scope='scope'>
                <div style='text-align: left'>
                    本店团购价：{{ scope.row.shopPrice }}
                </div>
                <div style='text-align: left'>市场价格：{{ scope.row.marketPrice }}</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' label='商品状态' width='150'>
            <template slot-scope='scope'>
                <el-tag type='info' v-if='scope.row.isShow == 0'>{{ computeProductStatus(scope.row.isShow) }}
                </el-tag>
                <el-tag type='success' v-if='scope.row.isShow == 1'>{{ computeProductStatus(scope.row.isShow)
                    }}
                </el-tag>
                <el-tag type='info' v-if='scope.row.isShow == 2'>{{ computeProductStatus(scope.row.isShow) }}
                </el-tag>
                <el-tag type='warning' v-if='scope.row.isShow == 3'>{{ computeProductStatus(scope.row.isShow)
                    }}
                </el-tag>
                <el-tag type='danger' v-if='scope.row.isShow == 4'>{{ computeProductStatus(scope.row.isShow)
                    }}
                </el-tag>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="stockSize"
        label="库存数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="saleSize"
        label="销售数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="buyMinLimit"
        label="一次最少团购数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="buyMaxLimit"
        label="一次最多团购数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="buyLimit"
        label="一个账号限购数量"
        width="180"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="storeId"
            label="所属门店"
            width="180"
        >
            <template slot-scope='scope'>
                <div v-if='scope.row.store'>{{ scope.row.store.storeName }}</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStoreGroupbuy(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopStoreGroupbuy(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopStoreGroupbuy(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStoreGroupbuyStates[shopStoreGroupbuyState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStoreGroupbuy"
          ref="shopStoreGroupbuyForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
            <el-tabs type="border-card">
                <el-tab-pane label="基本信息">
                    <el-form-item
                        label="商品名称"
                        prop="productName"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.productName"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="商品货号"
                        prop="productNumber"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.productNumber"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <el-input :disabled="shopStoreGroupbuyState == 'check'" style="width: 130px" size="small" v-model="shopStoreGroupbuy.productNumber"></el-input>
                        <el-button
                            :disabled="shopStoreGroupbuyState == 'check'"
                            type="primary"
                            @click="genProductNum"
                            size="small"
                            style="margin-left: 10px; width: 60px"
                        >生成</el-button
                        >
                    </el-form-item>
                    <el-form-item
                        label="所属门店"
                        prop="storeId"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.storeId"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <GridSelectShop
                            style="width: 200px"
                            title="选择所属店铺"
                            labelName="storeName"
                            labelValue="id"
                            :value="shopStoreGroupbuy.storeId"
                            :limit="1"
                            size="small"
                            :disabled="shopStoreGroupbuyState == 'check'"
                            @getValue="getShopId"
                            :columns="STORE_code"
                            :searchs="STORE_search"
                            dataListUrl="/shop/store/findList"
                            entityBeanName="shopStore"
                            queryEntityUrl="/shop/store/get"
                        >
                        </GridSelectShop>
                    </el-form-item>
                    <el-form-item
                        label="本店团购价"
                        prop="shopPrice"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.shopPrice"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="市场价格"
                        prop="marketPrice"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.marketPrice"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="库存数量"
                        prop="stockSize"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.stockSize"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="销售数量"
                        prop="saleSize"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.saleSize"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="一次最少团购数量"
                        prop="buyMinLimit"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.buyMinLimit"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="一次最多团购数量"
                        prop="buyMaxLimit"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.buyMaxLimit"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="一个账号限购数量"
                        prop="buyLimit"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            placeholder="请填写限购数量，0不限购"
                            v-model="shopStoreGroupbuy.buyLimit"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="排序"
                        prop="sort"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.sort"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <el-input-number
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.sort"
                            size="small"
                            label=""
                            :disabled="shopStoreGroupbuyState == 'check'"
                            :min="1"
                            :max="100"
                            :step="10"
                            :controls="true"
                            controls-position="both"
                        >
                        </el-input-number>
                    </el-form-item>
                    <el-form-item
                        label="商品状态"
                        prop="isShow"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.isShow"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <el-select
                            :disabled="shopStoreGroupbuyState == 'check'"
                            size="small"
                            style="width: 200px"
                            v-model="shopStoreGroupbuy.isShow"
                        >
                            <el-option
                                v-for="isShow in productStatusEnumList"
                                :key="isShow.key"
                                :label="isShow.value"
                                :value="isShow.key"
                            > </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="缩略图"
                        prop="productPic"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            style="width: 200px"-->
<!--                            v-model="shopStoreGroupbuy.productPic"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <el-upload
                            :disabled="shopStoreGroupbuyState == 'check'"
                            style="width: 200px"
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="uploadAvatar"
                        >
                            <img v-if="shopStoreGroupbuy.productPic" :src="shopStoreGroupbuy.productPic" class="avatar" size="small" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="商品相册">
                    <el-form-item
                        label="产品相册"
                        prop="productAlbum"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.productAlbum"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <el-upload
                            :headers="header"
                            class="uploadAlbum"
                            :action="action"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleSuccess"
                            :before-upload="beforeAvatarUpload"
                            list-type="picture"
                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                            :limit="10"
                            :disabled="shopStoreGroupbuyState == 'check'"
                        >
                            <el-button size="small" :disabled="shopStoreGroupbuyState == 'check'" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="视频地址"
                        prop="productVideo"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.productVideo"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <el-upload
                            class="uploadAlbum"
                            action=""
                            :disabled="shopStoreGroupbuyState == 'check'"
                            :file-list="videoFileList"
                            :before-upload="handleBeforeUpload"
                            :on-remove="handleVodRemove"
                            :http-request="uploadAvatar"
                            :on-success="onSucc"
                            list-type="picture"
                            :limit="1"
                        >
                            <el-button size="small" type="primary" :disabled="shopStoreGroupbuyState == 'check'">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过50mb</div>
                        </el-upload>
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="商品描述">
                    <el-form-item
                        label="详细详情"
                        prop="productContent"
                    >
<!--                        <el-input-->
<!--                            size="small"-->
<!--                            v-model="shopStoreGroupbuy.productContent"-->
<!--                            :disabled="shopStoreGroupbuyState == 'check'"-->
<!--                        ></el-input>-->
                        <WangEditor ref="contentEditor" :disabled="shopStoreGroupbuyState == 'check'" v-model="shopStoreGroupbuy.productContent" />
                    </el-form-item>
                </el-tab-pane>
            </el-tabs>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStoreGroupbuyState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH, UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';
import WangEditor from '@/components/common/wangeditor.vue';

export default {
    components: {
        WangEditor,
        GridSelectShop,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStoreGroupbuyList();
                    this.getShopStoreGroupbuyList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStoreGroupbuyList();
                    this.getShopStoreGroupbuyList();
                    this.$emit('resetCheckState');
                }
            },
            // 监听分类id
            shopStoreGroupbuy: {
                handler(newVal, oldVal) {
                    if (Object.keys(newVal).length != 0) {
                        //视频不为空
                        this.videoFileList = [];
                        if (this.shopStoreGroupbuy.productVideo) {
                            this.videoFileList.push({
                                name: this.shopStoreGroupbuy.productVideo,
                                url: this.shopStoreGroupbuy.productVideo
                            });
                        }

                        console.log(this.videoFileList);
                        this.$nextTick(()=>{
                            this.$refs.contentEditor.init(this.shopStoreGroupbuy.productContent);
                        })
                        console.log(this.shopStoreGroupbuy);
                        this.fileList = [];
                        if (this.shopStoreGroupbuy.productAlbum) {
                            let str = this.shopStoreGroupbuy.productAlbum;
                            var list = str.split('|');

                            this.fileList = list.map((item) => {
                                return {
                                    name: item,
                                    url: item
                                };
                            });
                            this.temporaryList = [];
                            for (let item of list) {
                                this.temporaryList.push(item);
                            }
                            this.albumList = '';
                            this.albumList = this.temporaryList.join('|');
                        }
                        console.log(this.temporaryList);
                    }
                    console.log(this.fileList);
                    console.log(newVal);
                },
                immediate: true,
                deep: true
            },
        },
    data() {
            return {
                queryForm:{
                     productName: '', //商品名称
                     productNumber: '', //商品货号
                     shopPrice: '', //本店团购价
                     marketPrice: '', //市场价格
                     productPic: '', //缩略图
                     productVideo: '', //视频地址
                     productAlbum: '', //产品相册
                     productContent: '', //详细描述（内容）
                     storeId: '', //所属门店
                     sort: '', //排序
                     isShow: '', //0下架，1上架
                     stockSize: '', //库存数量
                     saleSize: '', //销售数量
                     buyMinLimit: '', //一次最少团购数量
                     buyMaxLimit: '', //一次最多团购数量
                     buyLimit: '', //一个账号限购数量
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStoreGroupbuyState: 'add',
                shopStoreGroupbuyStates: {
                    add: '新建团购商品',
                    check: '查看团购商品',
                    edit: '修改团购商品'
                },
                srcList: [],
                multipleSelection: [],
                shopStoreGroupbuyList: [],
                shopStoreGroupbuy: {
                    id: '', //
                    productName: '', //商品名称
                    productNumber: '', //商品货号
                    shopPrice: '', //本店团购价
                    marketPrice: '', //市场价格
                    productPic: '', //缩略图
                    productVideo: '', //视频地址
                    productAlbum: '', //产品相册
                    productContent: '', //详细描述（内容）
                    storeId: '', //所属门店
                    sort: '', //排序
                    isShow: '', //0下架，1上架
                    stockSize: '', //库存数量
                    saleSize: '', //销售数量
                    buyMinLimit: '', //一次最少团购数量
                    buyMaxLimit: '', //一次最多团购数量
                    buyLimit: '', //一个账号限购数量
                },
                btnLoading: false,
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                    productNumber: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                    shopPrice: [{ required: true, message: '本店团购价不能为空', trigger: 'blur' }],
                    marketPrice: [{ required: true, message: '市场价格不能为空', trigger: 'blur' }],
                    productPic: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
                    // productVideo: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                    // productAlbum: [{ required: true, message: '产品相册不能为空', trigger: 'blur' }],
                    // productContent: [{ required: true, message: '详细描述（内容）不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '所属门店不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    isShow: [{ required: true, message: '0下架，1上架不能为空', trigger: 'blur' }],
                    stockSize: [{ required: true, message: '库存数量不能为空', trigger: 'blur' }],
                    saleSize: [{ required: true, message: '销售数量不能为空', trigger: 'blur' }],
                    buyMinLimit: [{ required: true, message: '一次最少团购数量不能为空', trigger: 'blur' }],
                    buyMaxLimit: [{ required: true, message: '一次最多团购数量不能为空', trigger: 'blur' }],
                    buyLimit: [{ required: true, message: '一个账号限购数量不能为空', trigger: 'blur' }],
                },

                productStatusEnumList: [],

                header: {
                    token: localStorage.getItem('token')
                },
                fileList: [],
                videoFileList: [],

                temporaryList: [],
                action: UPLOAD_API + UPLOAD_PATH,
                fileType: ['mp4'],
                // 上传文件大小限制(MB)
                fileSize: '50',
                albumList: '',
            };
        },
        created() {
            this.getShopStoreGroupbuyList();
            this.getProductStatusEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },

            // 删除图片
            handleRemove(file, fileList) {
                for (let i = 0; i < this.temporaryList.length; i++) {
                    if (!file.response) {
                        if (file.url == this.temporaryList[i]) {
                            this.temporaryList.splice(i, 1);
                        }
                    } else {
                        if (file.response.url == this.temporaryList[i]) {
                            this.temporaryList.splice(i, 1);
                        }
                    }
                }
                this.albumList = this.temporaryList.join('|');
            },
            //上传成功
            handleSuccess(response, file, fileList) {
                console.log(this.temporaryList);
                console.log(file);
                console.log(fileList);
                // this.temporaryList = [];
                this.temporaryList.push(file.response.url);
                console.log(this.temporaryList);
                this.albumList = this.temporaryList.join('|');

                console.log(this.albumList);
            },
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            //上传图片限制
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 50MB!');
                }
                return isLt2M;
            },

            //上传缩略图
            uploadAvatar(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    if (res.success) {
                        this.shopStoreGroupbuy.productPic = res.url;
                        console.log(this.shopStoreGroupbuy.productPic);
                    }
                });
            },
            // 获取商品状态枚举
            getProductStatusEnum() {
                get('/mpp/utils/getEnum', {
                    enumType: 'product_status'
                }).then((res) => {
                    if (res.success) {
                        this.productStatusEnumList = res.enumList;
                    }
                });
            },

            // 计算商品状态
            computeProductStatus(type) {
                for (let i = 0; i < this.productStatusEnumList.length; i++) {
                    if (this.productStatusEnumList[i].key == type) {
                        return this.productStatusEnumList[i].value;
                    }
                }
            },

            getValueShopId(value){
                this.queryForm.storeId = value
            },

            getShopId(value){
                this.shopStoreGroupbuy.storeId = value
            },

            resetShopStoreGroupbuyList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStoreGroupbuyList = [];
            },
            resetDialog() {
                this.shopStoreGroupbuyState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      productName: '', //商品名称
                      productNumber: '', //商品货号
                      shopPrice: '', //本店团购价
                      marketPrice: '', //市场价格
                      productPic: '', //缩略图
                      productVideo: '', //视频地址
                      productAlbum: '', //产品相册
                      productContent: '', //详细描述（内容）
                      storeId: '', //所属门店
                      sort: '', //排序
                      isShow: '', //0下架，1上架
                      stockSize: '', //库存数量
                      saleSize: '', //销售数量
                      buyMinLimit: '', //一次最少团购数量
                      buyMaxLimit: '', //一次最多团购数量
                      buyLimit: '', //一个账号限购数量
                };
                this.getShopStoreGroupbuyList();
            },
            //生成货号，货号不能为空
            genProductNum() {
                let dateTime;
                let yy = new Date().getFullYear();
                let mm = new Date().getMonth() + 1;
                let dd = new Date().getDate();
                let hh = new Date().getHours();
                let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
                let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
                dateTime = yy + '' + mm + '' + dd + '' + hh + '' + mf + '' + ss;
                this.shopStoreGroupbuy.productNumber = dateTime;
            },
            closeDialog() {
                this.showDialog = false
                this.shopStoreGroupbuy = {
                      id: '', //
                      productName: '', //商品名称
                      productNumber: '', //商品货号
                      shopPrice: '', //本店团购价
                      marketPrice: '', //市场价格
                      productPic: '', //缩略图
                      productVideo: '', //视频地址
                      productAlbum: '', //产品相册
                      productContent: '', //详细描述（内容）
                      storeId: '', //所属门店
                      sort: '', //排序
                      isShow: '', //0下架，1上架
                      stockSize: '', //库存数量
                      saleSize: '', //销售数量
                      buyMinLimit: '', //一次最少团购数量
                      buyMaxLimit: '', //一次最多团购数量
                      buyLimit: '', //一个账号限购数量
                };
            },
            submitForm() {
                if (this.shopStoreGroupbuyState == 'add') {
                    this.$refs.shopStoreGroupbuyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storegroupbuy/add`,{ ...this.shopStoreGroupbuy }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStoreGroupbuyList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStoreGroupbuyState == 'edit') {
                    this.$refs.shopStoreGroupbuyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            this.shopStoreGroupbuy.productAlbum = this.albumList;
                            delete this.shopStoreGroupbuy.store;
                            post(`/shop/storegroupbuy/edit`,{ ...this.shopStoreGroupbuy }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStoreGroupbuyList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStoreGroupbuy() {
                this.showDialog = true;
                this.shopStoreGroupbuyState = 'add';
            },
            checkShopStoreGroupbuy(shopStoreGroupbuyId) {
                console.log(shopStoreGroupbuyId);
                this.currentShopStoreGroupbuyId = shopStoreGroupbuyId;

                this.getShopStoreGroupbuyById();
                this.showDialog = true;
                this.shopStoreGroupbuyState = 'check';
            },
            onSucc(response, file, fileList) {
                console.log(this.videoFileList);
            },
            // 上传前校检格式和大小
            handleBeforeUpload(file) {
                console.log(this.shopStoreGroupbuy.productVideo);
                if (this.shopStoreGroupbuy.productVideo != '' && this.shopStoreGroupbuy.productVideo != null) {
                    this.$message({
                        message: '最多上传一个视频',
                        type: 'info',
                        duration: 2000
                    });
                    return false;
                }
                // 校检文件类型
                if (this.fileType && file) {
                    let fileExtension = '';
                    if (file.name.lastIndexOf('.') > -1) {
                        fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                    }
                    const isTypeOk = this.fileType.some((type) => {
                        if (file.type.indexOf(type) > -1) return true;
                        if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                        return false;
                    });
                    if (!isTypeOk && file) {
                        this.$message({
                            message: `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
                            type: 'error',
                            duration: 2000
                        });
                        return false;
                    }
                }
                // 校检文件大小;
                if (this.fileSize && file) {
                    const isLt = file.size / 1024 / 1024 < this.fileSize;
                    if (!isLt) {
                        this.$message({
                            message: `上传文件大小不能超过 ${this.fileSize} MB!`,
                            type: 'error',
                            duration: 2000
                        });
                        return false;
                    }
                }

                return true;
            },
            handleVodRemove(file, fileList) {
                // console.log(file);
                // console.log(fileList);
                if (fileList.length == 0) {
                    this.shopStoreGroupbuy.productVideo = '';
                    this.videoFileList = [];
                }
            },
            editShopStoreGroupbuy(shopStoreGroupbuyId) {
                console.log('shopStoreGroupbuy', shopStoreGroupbuyId);
                if (shopStoreGroupbuyId) {
                    this.currentShopStoreGroupbuyId = shopStoreGroupbuyId;
                    this.getShopStoreGroupbuyById();
                } else {
                    this.shopStoreGroupbuy = { ...this.shopStoreGroupbuy, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStoreGroupbuyState = 'edit';
            },
            deleteShopStoreGroupbuy(shopStoreGroupbuyId) {
                let ids = '';
                if (shopStoreGroupbuyId) {
                    ids = shopStoreGroupbuyId;
                } else {
                    ids = this.multipleSelection.map((shopStoreGroupbuy) => shopStoreGroupbuy.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storegroupbuy/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreGroupbuyList();
                                this.getShopStoreGroupbuyList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStoreGroupbuyList() {
                this.resetShopStoreGroupbuyList();
                this.getShopStoreGroupbuyList();
            },
            getShopStoreGroupbuyList(query = {}) {
                this.loading = true;
                get(`/shop/storegroupbuy/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStoreGroupbuyList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStoreGroupbuyById() {
                get(`/shop/storegroupbuy/get`,{ id: this.currentShopStoreGroupbuyId }).then((res) =>{
                    if(res.success){
                      this.shopStoreGroupbuy = { ...this.shopStoreGroupbuy, ...res.shopStoreGroupbuy };
                      this.$forceUpdate();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStoreGroupbuyList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storegroupbuy/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storegroupbuy/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storegroupbuy/importData`,formData);
              this.refreshShopStoreGroupbuyList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStoreGroupbuyList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStoreGroupbuyList();
            }
        }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
}

.classInput {
    width: 200px;
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}

.el-icon-arrow-down {
    font-size: 12px;
}

::v-deep .el-dropdown {
    font-size: 12px;
    color: #409eff;
}

::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-dropdown {
    font-size: 12px;
    color: #409eff;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

::v-deep .el-upload--text{
    font-size: 28px;
    color: #8c939d;
    width: 200px !important;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
}

.classInput {
    width: 200px;
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}

.el-icon-arrow-down {
    font-size: 12px;
}

</style>